var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevrolet101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29395 16.3064L3.50331 16.3071L5.56148 12.2335L5.35203 12.2328L3.29395 16.3064Z",
    fill: "url(#paint0_linear_1467_5813)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0636 9.33352L16.0304 9.71933H20.1965C20.3332 9.71933 20.41 9.75352 20.4616 9.85547L20.9229 9.44749C20.9229 9.44749 20.8069 9.33352 20.5958 9.33352H16.0636Z",
    fill: "url(#paint1_linear_1467_5813)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.448 9.3336C11.3369 9.3336 11.2087 9.38828 11.1406 9.47295L11.4396 9.7959C11.4396 9.7959 11.4993 9.71942 11.7385 9.71942H16.0299L16.0631 9.3336H11.448Z",
    fill: "url(#paint2_linear_1467_5813)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0332 9.7017V10.8776C11.0332 11.0621 10.9961 11.1074 10.9961 11.1074L11.3259 11.4561C11.3259 11.4561 11.3731 11.3357 11.3731 11.2617V10.0966C11.3731 10.023 11.3797 9.91584 11.3797 9.91584L11.07 9.53431C11.07 9.53431 11.0332 9.601 11.0332 9.7017Z",
    fill: "url(#paint3_linear_1467_5813)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6496 9.88014C20.6496 9.88014 20.6406 10.0169 20.6406 10.0905C20.6406 10.164 20.6496 11.1572 20.6496 11.231C20.6496 11.3045 20.7573 11.4409 20.7573 11.4409L21.1519 11.0935C21.1519 11.0935 21.0583 11.0622 21.0583 10.8776V9.70179C21.0583 9.60109 20.9755 9.53439 20.9755 9.53439L20.6496 9.88014Z",
    fill: "url(#paint4_linear_1467_5813)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5681 11.3417C10.4444 11.3417 6.19442 11.3466 5.96796 11.3466C5.63937 11.3466 5.44613 11.4908 5.44613 11.4908L5.71644 11.8525C5.71644 11.8525 5.82457 11.72 6.0632 11.72H10.8588C11.0258 11.72 11.1513 11.6448 11.1513 11.6448L10.838 11.2704C10.838 11.2704 10.6841 11.3417 10.5681 11.3417Z",
    fill: "url(#paint5_linear_1467_5813)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16735 16.6115L2.67729 16.9534C2.67729 16.9534 2.63844 17.0947 2.71166 17.2064C2.78506 17.3177 2.89712 17.335 2.89712 17.335L3.53496 16.8817C3.53496 16.8817 3.17397 16.8648 3.32417 16.5989C3.47437 16.3328 3.46622 16.2326 3.46622 16.2326C3.46622 16.2326 3.29096 16.2612 3.16735 16.6115Z",
    fill: "url(#paint6_linear_1467_5813)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51325 13.2635C4.12246 14.0636 2.8099 16.6339 2.76398 16.7257C2.71797 16.8171 2.67188 16.9771 2.67188 16.9771L3.17769 16.6111L5.5478 11.9141C5.5478 11.9141 4.90414 12.4629 4.51325 13.2635Z",
    fill: "url(#paint7_linear_1467_5813)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54464 16.8927L2.89453 17.3579C2.89453 17.3579 10.2996 17.3761 10.4867 17.3761C10.6735 17.3761 10.752 17.4116 10.752 17.4116L11.0855 17.0346C11.0855 17.0346 10.7669 16.8927 10.59 16.8927H3.54464Z",
    fill: "url(#paint8_linear_1467_5813)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9424 17.6179C10.9424 17.6179 11.0106 17.7543 11.0106 17.863V18.837C11.0106 18.9763 11.0652 19.0972 11.0652 19.0972L11.3906 18.7159V17.5491C11.3906 17.3629 11.2873 17.2063 11.2873 17.2063L10.9424 17.6179Z",
    fill: "url(#paint9_linear_1467_5813)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4492 17.4284V18.5952L20.9599 19.0396C20.9599 19.0396 20.9725 18.9211 20.9725 18.782V17.8076C20.9725 17.699 21.0042 17.6306 21.0042 17.6306L20.5577 17.1865C20.5577 17.1865 20.4492 17.2418 20.4492 17.4284Z",
    fill: "url(#paint10_linear_1467_5813)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.067 18.7901H16.0527V19.332H20.4948C20.6458 19.332 20.8219 19.2321 20.8553 19.2068L20.3519 18.7319C20.3519 18.7319 20.3187 18.7901 20.067 18.7901Z",
    fill: "url(#paint11_linear_1467_5813)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2178 19.264C11.2178 19.264 11.3212 19.3369 11.6101 19.3369C11.8988 19.3369 16.053 19.3317 16.053 19.3317V18.7898H11.7653C11.6877 18.7898 11.6358 18.7754 11.6358 18.7754L11.2178 19.264Z",
    fill: "url(#paint12_linear_1467_5813)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3714 10.2194C12.1389 10.2194 11.9067 10.348 11.9067 10.6049V11.8632C11.9067 12.1197 11.7517 12.2225 11.5711 12.2225H6.43055C6.22173 12.2225 6.06017 12.3092 5.96735 12.484C5.89135 12.6276 4.60761 15.187 4.19274 16.0142C4.10278 16.1936 4.18137 16.3027 4.41221 16.3027H11.5971C11.9067 16.3027 11.9585 16.5853 11.9585 16.8676V17.8454C11.9585 18.0255 12.139 18.231 12.3456 18.231H15.96V10.2194H12.3714Z",
    fill: "url(#paint13_linear_1467_5813)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7881 17.0001L21.202 17.4233C21.202 17.4233 21.3053 17.3664 21.7883 17.3664H26.2023C26.2941 17.3664 26.4205 17.3206 26.4205 17.3206L24.0872 16.8519C24.0872 16.8519 21.3858 16.8538 21.2594 16.8519C21.2547 16.8517 21.25 16.8516 21.2452 16.8516C20.9713 16.8516 20.7881 17.0001 20.7881 17.0001Z",
    fill: "url(#paint14_linear_1467_5813)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9434 11.594C20.9434 11.594 21.1451 11.6611 21.3098 11.6611H28.2599C28.4714 11.6611 28.5949 11.6768 28.5949 11.6768L29.1565 11.3437C29.1565 11.3437 28.9763 11.2926 28.796 11.2926H21.5781C21.3977 11.2926 21.3225 11.2506 21.3225 11.2506L20.9434 11.594Z",
    fill: "url(#paint15_linear_1467_5813)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8002 11.857C28.8002 11.857 28.832 12.0324 28.7719 12.1516C28.712 12.2707 26.6113 16.3805 26.5165 16.5693C26.4214 16.758 26.207 16.8275 26.207 16.8275L26.4465 17.3037C26.4465 17.3037 26.5312 17.2396 26.5814 17.1749C26.6312 17.1104 29.216 11.8784 29.2959 11.6949C29.3756 11.5112 29.3055 11.4448 29.3055 11.4448L28.8002 11.857Z",
    fill: "url(#paint16_linear_1467_5813)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.984 16.8627C25.7082 16.8627 24.1562 16.8745 24.1562 16.8745L26.3634 17.3203C26.3634 17.3203 26.5014 17.2636 26.5704 17.1487C26.6395 17.0344 26.5701 17.0002 26.4898 17.0688C26.4095 17.1378 26.2716 17.0235 26.3404 16.9433C26.4096 16.8628 26.4783 16.6113 26.4783 16.6113C26.4783 16.6113 26.2601 16.8627 25.984 16.8627Z",
    fill: "url(#paint17_linear_1467_5813)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45208 16.5092C4.00668 16.6052 3.54509 16.877 3.54509 16.877H10.4473C11.2322 16.877 11.1426 16.9838 11.1382 16.9886L11.7002 16.3975C11.7002 16.3975 10.335 16.3975 9.46763 16.3816C9.35736 16.3796 9.23365 16.3787 9.09858 16.3787C8.17154 16.3787 6.7138 16.4257 5.45208 16.5092Z",
    fill: "url(#paint18_linear_1467_5813)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7321 16.3815C21.1181 16.3974 20.1512 16.3974 20.1512 16.3974L20.7956 17.001C20.7956 17.001 20.8619 16.8597 21.4305 16.8597C21.9994 16.8597 26.0991 16.8457 26.0991 16.8457C26.0991 16.8457 26.1683 16.6227 24.9611 16.5371C24.0101 16.4695 22.5751 16.3799 21.8814 16.3799C21.8316 16.3799 21.7819 16.3804 21.7321 16.3815Z",
    fill: "url(#paint19_linear_1467_5813)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2716 12.2857C20.2716 12.2857 21.2388 12.2857 21.853 12.3017C22.4672 12.3176 26.1902 12.1497 27.2141 12.0537C28.238 11.9579 28.5647 11.6861 28.5647 11.6861C28.5647 11.6861 22.0552 11.7207 21.4865 11.7207C20.9181 11.7207 20.9974 11.6086 20.9974 11.6086L20.2716 12.2857Z",
    fill: "url(#paint20_linear_1467_5813)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3213 17.2232C11.3213 17.2232 11.3903 17.446 11.3903 17.6176V18.3894C11.3903 18.5951 11.4594 18.6982 11.4594 18.6982L12.0456 18.1149C12.0456 18.1149 11.9581 17.9092 11.9581 17.7548V16.8846C11.9581 16.6834 11.9076 16.5197 11.9076 16.5197L11.3213 17.2232Z",
    fill: "url(#paint21_linear_1467_5813)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9234 16.8797C19.9234 17.0809 19.9098 17.6194 19.9098 17.774C19.9098 17.928 19.8742 18.1149 19.8742 18.1149L20.4603 18.6982C20.4603 18.6982 20.5295 18.595 20.5295 18.3894V17.6176C20.5295 17.446 20.5984 17.2232 20.5984 17.2232L19.9707 16.5035C19.9402 16.6266 19.9244 16.7529 19.9234 16.8797Z",
    fill: "url(#paint22_linear_1467_5813)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6493 18.7666L15.9254 18.8008L15.9426 18.8004V18.2307L12.2182 18.2174L11.6493 18.7666Z",
    fill: "url(#paint23_linear_1467_5813)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9596 18.2311H15.9424V18.8008L20.3392 18.75L19.6324 18.2177L15.9596 18.2311Z",
    fill: "url(#paint24_linear_1467_5813)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7072 9.716C11.5865 9.716 11.4748 9.78073 11.4748 9.78073L12.0415 10.3354C12.0415 10.3354 12.0974 10.215 12.4968 10.215H15.9601V9.716H11.7072Z",
    fill: "url(#paint25_linear_1467_5813)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9601 9.71629V10.2153H19.4234C19.8228 10.2153 19.9055 10.3882 19.9055 10.3882L20.4721 9.83373C20.4721 9.83373 20.3339 9.71629 20.2131 9.71629H15.9601Z",
    fill: "url(#paint26_linear_1467_5813)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3662 10.2007V11.208C11.3662 11.3275 11.3135 11.469 11.3135 11.469L11.8685 12.0957C11.8685 12.0957 11.906 12.0436 11.906 11.7826C11.906 11.5215 11.9284 10.4996 11.9284 10.4996L11.3735 9.88039C11.3735 9.88039 11.3662 10.0441 11.3662 10.2007Z",
    fill: "url(#paint27_linear_1467_5813)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9285 10.5116V11.764C19.9285 12.0251 20.0513 12.0957 20.0513 12.0957L20.7296 11.416C20.7296 11.416 20.6411 11.2738 20.6411 11.1546C20.6411 11.0351 20.6354 10.3069 20.6354 10.1503C20.6354 9.99365 20.6423 9.84878 20.6423 9.84878L19.9285 10.5116Z",
    fill: "url(#paint28_linear_1467_5813)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9079 11.7341H6.1491C6.01117 11.7341 5.78686 11.7856 5.71794 11.8543L6.1491 12.3003C6.1491 12.3003 6.26967 12.2146 6.5629 12.2146H11.5114C11.6495 12.2146 11.7873 12.1629 11.7873 12.1629L11.2357 11.5971C11.2357 11.5971 11.0976 11.7341 10.9079 11.7341Z",
    fill: "url(#paint29_linear_1467_5813)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7305 16.3217C25.7305 16.3217 25.9969 16.222 26.0803 16.5368C26.0803 16.5368 26.1469 16.6365 26.33 16.3711C26.5131 16.1062 28.2455 12.5616 28.2283 12.5114C28.2116 12.4618 27.8619 12.3954 27.8619 12.3954L25.7305 16.3217Z",
    fill: "url(#paint30_linear_1467_5813)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9116 12.4291C27.9951 12.4786 28.0783 12.545 27.9617 12.7933C27.8453 13.0414 26.5129 15.6259 26.2301 16.1227C25.947 16.6195 26.1964 16.8184 26.1964 16.8184C26.1964 16.8184 26.4132 16.7187 26.4783 16.6113C26.544 16.5036 28.5781 12.495 28.7182 12.2259C28.8582 11.9566 28.761 11.8489 28.761 11.8489L27.9116 12.4291Z",
    fill: "url(#paint31_linear_1467_5813)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9601 10.2194V18.231H19.5213C19.7276 18.231 19.9085 18.1539 19.9085 17.9223V16.7275C19.9085 16.4965 20.0631 16.3171 20.244 16.3171H25.6163C25.8048 16.3171 25.9741 16.2073 26.0723 16.0268C26.5113 15.2194 27.7203 12.8779 27.8117 12.6891C27.9234 12.4587 27.8543 12.3252 27.5955 12.3252H20.4762C20.1665 12.3252 19.9339 12.0943 19.9339 11.8118V10.5021C19.9339 10.3223 19.8307 10.2195 19.5985 10.2195L15.9601 10.2194Z",
    fill: "url(#paint32_linear_1467_5813)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4873 16.6538L4.17652 16.2381C4.17652 16.2381 4.09758 16.2039 4.22164 15.9568C4.34587 15.7097 5.50958 13.3495 5.50958 13.3495L5.24992 13.2935L3.4873 16.6538Z",
    fill: "url(#paint33_linear_1467_5813)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42463 16.3482C3.25215 16.657 3.28688 16.7769 3.28688 16.7769L3.70059 16.5024C3.70059 16.5024 5.54546 12.952 5.73513 12.5402C5.92489 12.1286 5.64213 11.961 5.64213 11.961C5.64213 11.961 3.59712 16.0395 3.42463 16.3482Z",
    fill: "url(#paint34_linear_1467_5813)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70339 16.8914C3.67604 16.9096 3.42389 16.9406 3.37461 16.8914C3.32526 16.8427 3.24283 16.8045 3.30865 16.7498C3.37468 16.695 4.18561 16.2155 4.18561 16.2155C4.18561 16.2155 4.08712 16.27 4.9204 16.27H11.5859C11.7614 16.27 11.9257 16.3897 11.9478 16.4661C11.9697 16.5426 11.9258 16.5752 11.871 16.5645C11.8164 16.5534 11.6737 16.5098 11.6408 16.4551C11.6079 16.4008 11.6847 16.3571 11.2022 16.3571C10.7198 16.3571 7.03625 16.4118 6.20324 16.488C5.36995 16.5645 4.27331 16.5098 3.70339 16.8914ZM28.3235 11.7001C28.3507 11.6822 28.6032 11.6513 28.6524 11.7001C28.7017 11.7492 28.7841 11.7874 28.7183 11.842C28.6524 11.8964 27.8412 12.3763 27.8412 12.3763C27.8412 12.3763 27.9396 12.3219 27.1065 12.3219H20.4408C20.2654 12.3219 20.101 12.2021 20.0792 12.1256C20.0572 12.049 20.1009 12.0162 20.1555 12.0273C20.2108 12.0384 20.3531 12.082 20.3861 12.1363C20.4188 12.1911 20.342 12.2343 20.8246 12.2343C21.3071 12.2343 24.9902 12.18 25.8239 12.1037C26.6568 12.0273 27.7536 12.082 28.3234 11.7001M5.85549 12.331C5.85549 12.2538 5.89856 12.1081 5.8642 12.0654C5.82963 12.0224 5.93306 11.971 6.00212 12.0136C6.07112 12.0566 6.21755 12.0908 6.23477 12.1253C6.25205 12.1595 6.22619 12.2451 6.13141 12.2795C6.03649 12.3137 5.95028 12.391 5.80378 12.708C5.65714 13.0257 4.82082 14.6379 4.82082 14.6379C4.82082 14.6379 4.94167 14.3807 4.88989 14.3719C4.83817 14.3634 4.7176 14.5779 4.7176 14.5779L5.85549 12.331ZM11.62 12.1793C11.5487 12.1865 11.5288 12.1087 11.5896 12.0986C11.6508 12.0884 11.7318 12.0836 11.8028 11.8055C11.8741 11.5275 11.8234 10.684 11.8131 10.5326C11.8028 10.381 11.7319 10.1993 11.8336 10.1185C11.935 10.0375 12.0062 10.2094 12.2703 10.2094C12.5343 10.2094 13.1336 10.1892 13.1336 10.1892C13.1336 10.1892 12.2906 10.2494 12.1482 10.2699C12.0061 10.2902 11.8842 10.4012 11.9044 10.6033C11.9249 10.8054 11.8741 11.8462 11.8336 11.9573C11.7929 12.0683 11.7216 12.1692 11.62 12.1793ZM17.3075 10.1954C17.1956 10.2006 19.4491 10.2218 19.5911 10.2218C19.7333 10.2218 19.8958 10.2647 19.9263 10.406C19.9568 10.5476 19.9352 11.0113 19.9352 11.0113C19.9352 11.0113 20.0052 10.4161 20.1069 10.3051C20.2084 10.1937 20.1779 10.0323 20.046 10.0622C19.9138 10.0929 18.8681 10.1254 17.3075 10.1954ZM20.3167 16.3894C20.2458 16.3789 20.1648 16.3693 20.1443 16.4297C20.1239 16.4899 20.2354 16.5303 20.1239 16.5906C20.0128 16.6511 19.9298 16.6883 19.9298 16.6378C19.9298 16.5874 19.9872 16.3285 20.2001 16.3285C20.413 16.3285 25.6653 16.3185 25.7469 16.3185C25.8276 16.3185 25.9291 16.3285 25.9695 16.4094C26.01 16.4901 26.0606 16.6915 26.0912 16.7521C26.1214 16.8126 26.071 16.8126 25.9795 16.6915C25.8883 16.5705 25.6556 16.5203 25.4734 16.5303C25.2908 16.5404 20.3167 16.3894 20.3167 16.3894ZM26.1113 16.5606C26.1113 16.5606 26.0608 16.4499 26.0302 16.3789C25.9999 16.3087 25.9087 16.2787 25.9087 16.2787C25.9087 16.2787 26.0099 16.1573 26.1516 15.8956C26.2937 15.6339 26.9623 14.3838 27.0331 14.2125C27.0331 14.2125 26.8812 14.6765 27.175 14.2931C27.175 14.2931 26.2227 16.0867 26.1618 16.2078C26.1012 16.3289 26.1112 16.5606 26.1112 16.5606M12.0212 17.9712C12.0212 17.9712 12.0333 18.1162 11.9487 18.1763C11.864 18.2366 11.8276 18.345 11.9003 18.3933C11.9729 18.4414 12.0213 18.4174 12.0697 18.345C12.1182 18.2728 12.2879 18.2124 12.3968 18.2367C12.3969 18.2366 12.0212 18.2844 12.0212 17.9712ZM17.2422 18.2294C17.2422 18.2294 19.2866 18.3365 19.4077 18.3422L19.6136 18.3515C19.6136 18.3515 19.3966 18.3173 19.4608 18.248L17.2422 18.2294H17.2422ZM19.6652 18.2125C19.6652 18.2125 19.6048 18.3089 19.7015 18.3568C19.7987 18.4049 19.8957 18.4531 19.9562 18.3809C20.0166 18.3087 19.9078 18.1159 19.9197 17.9834C19.9197 17.9833 19.9682 18.1884 19.6652 18.2125Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1588 18.3871H22.0455V18.578H22.1588C22.2164 18.578 22.2335 18.5552 22.2335 18.5177V18.4471C22.2335 18.3989 22.2109 18.3871 22.1588 18.3871ZM22.1588 18.6398H22.0455V18.7968H21.9767V18.3243H22.1588C22.2619 18.3243 22.3023 18.37 22.3023 18.4472V18.5178C22.3023 18.569 22.2845 18.6035 22.2335 18.6262L22.3612 18.7968H22.2797L22.1588 18.6398ZM22.1376 18.9406C22.3807 18.9406 22.5083 18.7748 22.5083 18.5714C22.5083 18.3679 22.3807 18.1996 22.1376 18.1996C21.8942 18.1996 21.7635 18.3679 21.7635 18.5714C21.7635 18.7748 21.8941 18.9406 22.1376 18.9406ZM22.1376 18.1372C22.4069 18.1372 22.5715 18.331 22.5715 18.5706C22.5715 18.8068 22.407 19.0035 22.1376 19.0035C21.8665 19.0035 21.7006 18.8068 21.7006 18.5706C21.7006 18.331 21.8665 18.1372 22.1376 18.1372ZM8.27943 21.2517H7.52723V20.2993H6.80129V22.6669H7.52723V21.6461H8.27943V22.6669H9.00612V20.2992H8.27943V21.2517ZM21.6343 22.2727V20.2991H20.9081V22.6667H22.6735V22.2727H21.6343ZM25.7625 20.2991V20.6941H26.4234V22.6669H27.1491V20.6941H27.8105V20.2992L25.7625 20.2991ZM4.1818 20.7921C4.1818 20.4962 4.36152 20.2991 4.63102 20.2991H6.08723V20.6936H5.04324C4.96209 20.6936 4.90869 20.7535 4.90869 20.842V22.1241C4.90869 22.2132 4.96203 22.2728 5.04324 22.2728H6.08723V22.6668H4.63102C4.36152 22.6668 4.1818 22.4692 4.1818 22.1737V20.7921ZM16.8122 21.7063L17.44 22.6668H16.668L16.1123 21.6902V21.3815H16.4123C16.4931 21.3815 16.5469 21.3215 16.5469 21.2332V20.8418C16.5469 20.7533 16.4931 20.6939 16.4123 20.6939H15.9043V22.6668H15.1778V20.2992H16.8243C17.0945 20.2992 17.2733 20.4962 17.2733 20.7922L17.274 21.2706C17.2741 21.5314 17.1159 21.7063 16.8774 21.7063H16.8122ZM19.3296 22.2727C19.41 22.2727 19.464 22.2132 19.464 22.1246V20.8418C19.464 20.7535 19.41 20.6936 19.3296 20.6936H18.8231C18.7424 20.6936 18.6881 20.7535 18.6881 20.8418V22.1246C18.6881 22.2132 18.7424 22.2727 18.8231 22.2727H19.3296ZM17.962 20.7921C17.962 20.4962 18.141 20.2991 18.4106 20.2991H19.7413C20.0106 20.2991 20.1907 20.4962 20.1907 20.7921V22.1738C20.1907 22.4693 20.0106 22.6668 19.7413 22.6668H18.4106C18.141 22.6668 17.962 22.4693 17.962 22.1738V20.7921ZM12.2375 20.2991H13.0164L13.4812 22.1295C13.4824 22.1372 13.4864 22.1441 13.4923 22.149C13.4982 22.1539 13.5058 22.1564 13.5134 22.1561C13.5299 22.1561 13.5428 22.1462 13.5458 22.1295L13.9977 20.2991H14.6073L14.0442 22.3309C13.9761 22.5622 13.8529 22.6668 13.5943 22.6668H13.2318C13.0655 22.6668 12.93 22.5814 12.8485 22.3292L12.2375 20.2991ZM10.4664 22.1979C10.4664 22.2434 10.4932 22.2723 10.5341 22.2723H11.7276V22.6668H10.189C9.9196 22.6668 9.74003 22.4692 9.74003 22.1742V20.7923C9.74003 20.4964 9.9196 20.2992 10.189 20.2992H11.7276V20.6941H10.534C10.4932 20.6941 10.4663 20.7235 10.4663 20.7681V21.2512H11.5905V21.646H10.4664V22.198V22.1979ZM23.9059 22.1979C23.9059 22.2434 23.9325 22.2723 23.9726 22.2723H25.1667V22.6668H23.6279C23.3586 22.6668 23.178 22.4692 23.178 22.1742V20.7923C23.178 20.4964 23.3586 20.2992 23.6279 20.2992H25.1666V20.6941H23.9726C23.9325 20.694 23.9059 20.7234 23.9059 20.7681V21.2512H25.0292V21.646H23.9059V22.198V22.1979Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1467_5813",
    x1: 5.42584,
    y1: 12.2977,
    x2: 5.41149,
    y2: 17.6361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1467_5813",
    x1: -13796.1,
    y1: 4987.33,
    x2: -13792.8,
    y2: 4984.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#92A5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#476886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1467_5813",
    x1: 12.4079,
    y1: 10.7557,
    x2: 15.7632,
    y2: 7.38269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#476886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#92A5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1467_5813",
    x1: 10.7758,
    y1: 10.8824,
    x2: 11.8687,
    y2: 9.85786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#C7D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1467_5813",
    x1: 21.3222,
    y1: 10.9145,
    x2: 20.165,
    y2: 9.82969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#C7D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1467_5813",
    x1: 6.87123,
    y1: 12.998,
    x2: 10.6345,
    y2: 9.21494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#476886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#92A5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1467_5813",
    x1: 3.29413,
    y1: 17.0105,
    x2: 2.85347,
    y2: 16.3778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#5E738F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1467_5813",
    x1: 5.68271,
    y1: 13.651,
    x2: 2.27609,
    y2: 15.3938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1467_5813",
    x1: 7.07643,
    y1: 17.6924,
    x2: 6.81735,
    y2: 16.2153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1467_5813",
    x1: 11.0286,
    y1: 18.1515,
    x2: 11.4635,
    y2: 18.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E738F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91AFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1467_5813",
    x1: 20.907,
    y1: 18.1129,
    x2: 20.3685,
    y2: 18.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E738F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91AFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1467_5813",
    x1: 17.8543,
    y1: 20.0357,
    x2: 19.3157,
    y2: 17.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1467_5813",
    x1: 13.1762,
    y1: 18.2274,
    x2: 14.6489,
    y2: 20.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#A5B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5B9CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1467_5813",
    x1: 8.7159,
    y1: 10.9036,
    x2: 15.2928,
    y2: 22.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC956E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1467_5813",
    x1: 22.6442,
    y1: 18.2239,
    x2: 24.4928,
    y2: 16.1525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E738F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#91AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1467_5813",
    x1: 24.0483,
    y1: 9.74237,
    x2: 26.4975,
    y2: 14.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#7F97B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#476886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1467_5813",
    x1: 26.2259,
    y1: 17.0748,
    x2: 30.2133,
    y2: 10.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E1E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#7F97B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#476886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1467_5813",
    x1: 25.1631,
    y1: 17.1564,
    x2: 26.5842,
    y2: 16.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#A5B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#002334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1467_5813",
    x1: 5.78276,
    y1: 14.8121,
    x2: 10.4188,
    y2: 19.4725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1467_5813",
    x1: 24.4382,
    y1: 15.3145,
    x2: 21.1268,
    y2: 18.6433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1467_5813",
    x1: 26.5364,
    y1: 9.87449,
    x2: 21.184,
    y2: 15.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1467_5813",
    x1: 11.4543,
    y1: 17.6087,
    x2: 12.1572,
    y2: 17.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F5F39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1467_5813",
    x1: 20.4751,
    y1: 17.6012,
    x2: 19.7721,
    y2: 17.6012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F5F39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1467_5813",
    x1: 13.4085,
    y1: 17.8284,
    x2: 14.7046,
    y2: 20.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#D3BD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1467_5813",
    x1: 18.5202,
    y1: 17.8308,
    x2: 17.1044,
    y2: 20.2961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#D3BD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1467_5813",
    x1: 12.7007,
    y1: 11.0005,
    x2: 15.7015,
    y2: 7.98386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D1AC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1467_5813",
    x1: 19.2501,
    y1: 11.0422,
    x2: 16.1969,
    y2: 7.97294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D1AC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1467_5813",
    x1: 11.1969,
    y1: 11.3741,
    x2: 12.3131,
    y2: 10.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D1AC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1467_5813",
    x1: 20.7757,
    y1: 11.3652,
    x2: 19.612,
    y2: 10.2744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D1AC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1467_5813",
    x1: 7.37186,
    y1: 13.3928,
    x2: 10.8542,
    y2: 9.89214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD9B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1467_5813",
    x1: 26.4269,
    y1: 13.8772,
    x2: 27.9085,
    y2: 15.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1467_5813",
    x1: 26.0617,
    y1: 16.6926,
    x2: 29.3243,
    y2: 10.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A78A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#674C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#674C2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1467_5813",
    x1: 23.9717,
    y1: 17.7865,
    x2: 14.6785,
    y2: 6.65293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC956E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1467_5813",
    x1: 3.21587,
    y1: 16.264,
    x2: 6.43129,
    y2: 13.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CF98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1467_5813",
    x1: 2.78409,
    y1: 16.1103,
    x2: 7.1098,
    y2: 11.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4CB90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrolet101);
export default __webpack_public_path__ + "static/media/chevrolet-10 1.8893b4709574fac1f2c7354276f45f5a.svg";
export { ForwardRef as ReactComponent };